import "./hero-block.scss";

const HeroBlock = () => {
  return (
    <section className="hero">
      <div className="hero__wrapper">
        <h1 className="hero__title">
          Узнайте, что ждет
          <br /> вас в&nbsp;2025&nbsp;году
        </h1>
        <p className="hero__text">
          Это&nbsp;волшебный конверт&nbsp;&mdash; при его производстве
          не&nbsp;пострадало ни&nbsp;одно дерево, за&nbsp;это природа наделила
          его способностью видеть будущее. Откройте конверт
          и&nbsp;он&nbsp;предскажет вашу судьбу
        </p>
      </div>
    </section>
  );
}

export default HeroBlock;
